import React, { useCallback } from 'react';
import { Redirect, useParams, useHistory } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import ProfessorSubjectsPanel, { useProfessorSubjectsPanel } from 'modules/subjects/components/ProfessorSubjectsPanel';
import SubjectPageHeader from '@ts-core/components/SubjectPageHeader';

import ToMainMenuButton from '@ts-core/components/ToMainMenuButton';

import { useSubject } from '../../hooks';

import useSubjectTabPages from './useSubjectTabPages';

const SubjectPage = () => {
  const history = useHistory();
  const { courseId, subjectId, tab } = useParams();

  const { subject } = useSubject({ courseId, subjectId });
  const { tabs, activePage, onGoToTab } = useSubjectTabPages();
  const { Component } = activePage || {};

  const navigateToSubject = useCallback(
    (mSubject) => {
      history.push(`/${courseId}/subjects/${mSubject._id}/${tab}`);
    },
    [history, courseId, tab]
  );

  const subjectsPanelProps = useProfessorSubjectsPanel({
    courseId,
    onSelectLeafSubject: navigateToSubject,
    showSelectedMark: true,
    selectedSubjectId: subjectId,
  });

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ToMainMenuButton noMargin />
        </Grid>
        <Grid item xs={12} md={4}>
          <ProfessorSubjectsPanel {...subjectsPanelProps} />
        </Grid>
        <Grid item xs={12} md={8}>
          <SubjectPageHeader title={subject?.name} tabs={tabs} activeTab={activePage?.tab} onGoToTab={onGoToTab} />
          {Component && <Component />}
        </Grid>
      </Grid>
      {!activePage && <Redirect to="exercises" />}
    </>
  );
};

export default SubjectPage;
